import React from 'react'
import clsx from 'clsx'
import { UserTick } from 'iconsax-react'
import { useTheme } from '@mui/material'

import ChipAutocomplete from '@SonarCX/components/atoms/ChipAutocomplete'
import { isUUID } from '@SonarCX/utilities'

type OwnerSectionProps = {
  classes: any
  canEdit?: boolean
  setModifiedTask: React.Dispatch<React.SetStateAction<boolean>>
  sendValues: (val: string, field: string) => void
  fullPage?: boolean
  ownerObj: any
  setOwnerObj: React.Dispatch<React.SetStateAction<any>>
}

const OwnerSection: React.FC<OwnerSectionProps> = ({
  classes,
  canEdit,
  setModifiedTask,
  sendValues,
  fullPage,
  ownerObj,
  setOwnerObj
}) => {
  const [value, setValue] = React.useState(null)
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        !fullPage && classes.container
      )}
    >
      <span className={clsx(classes.center, classes.label)}>
        <UserTick size={theme.size.base} variant='Bulk' color='#B64FCD' /> TASK
        OWNER
      </span>

      <div
        className={clsx(
          classes.input,
          !ownerObj && classes.upInput,
          classes.chipAvatar
        )}
      >
        <ChipAutocomplete
          placeholder={canEdit ? 'Type and Search...' : 'No assigned owner'}
          value={ownerObj?.id ?? value}
          onChange={id => {
            setValue(id)

            if (!id) {
              sendValues(null, 'owner_id')
              return
            }

            if (isUUID(id)) {
              sendValues(id, 'owner_id')
            }
          }}
          internal
          single
          includeMe
          disabled={!canEdit}
        />
      </div>
    </div>
  )
}

export default OwnerSection
